; (function (root, factory) {
    // UMD/AMDWeb module bolierplate: https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('AjaxSearch', ['jQuery'], factory);
    } else {
        // Browser globals
        root.AjaxSearch = factory(jQuery);
    }
}(typeof self !== 'undefined' ? self : this, function ($) {
        'use strict';

        function AjaxSearch(element, options) {
            this.container = element;
            if (!this.container) return;
            this.context = this.container.dataset.ajaxSearch;
            this.result = document.querySelector('[data-search-result="' + this.context + '"]');
            this.form = this.container.querySelector('.searchform');
            this.action = this.form.getAttribute('action');
            this.wait = 1000;
            this.input = this.container.querySelector('.inputbox');
            this.currentValue = this.input.value;

            this.handleFocus = this.handleFocus.bind(this);
            this.handleBlur = this.handleBlur.bind(this);
            this.handleKeyPress = this.handleKeyPress.bind(this);
            this.handleTimeout = this.handleTimeout.bind(this);
            this.handleResponse = this.handleResponse.bind(this);
            this.handleData = this.handleData.bind(this);
            this.handleError = this.handleError.bind(this);

            this.input.addEventListener('focus', this.handleFocus);
            this.input.addEventListener('blur', this.handleBlur);
            this.input.addEventListener('keyup', this.handleKeyPress);

            this.form.addEventListener('submit', function (event) {
                event.preventDefault();
            });
        }

        AjaxSearch.prototype = {
            handleFocus: function (event) {
                this.focus = true
            },
            handleBlur: function (event) {
                this.focus = false;
            },
            handleKeyPress: function (event) {
                if (this.typing) window.clearTimeout(this.typing);
                this.typing = window.setTimeout(this.handleTimeout, 450);
                this.currentValue = this.input.value;
                this.form.classList.add('-typing');
                this.result.classList.add('-loading');
            },
            handleTimeout: function () {
                this.typing = false;
                var value = this.input.value;
                if (value.length >= 2) {
                    this.requestTime = new Date().getTime();
                    $.post(this.action, $(this.form).serialize(), this.handleResponse)
                        .fail(this.handleError);
                } else {
                    $(this.result).html('');
                    this.form.classList.remove('-typing');
                    this.result.classList.remove('-loading');
                }
            },
            handleData: function (data) {
                var $data = $(data);
                var $result = $data.find('[data-search-result="' + this.context + '"]');
                $(this.result).html($result.children());
                this.form.classList.remove('-typing');
                this.result.classList.remove('-loading');
            },
            handleResponse: function (data) {
                var responseTime = new Date().getTime();
                if (responseTime - this.requestTime > this.wait) {
                    this.handleData(data);
                } else {
                    var timeout = this.wait - (responseTime - this.requestTime);
                    window.setTimeout(this.handleData, timeout, data);
                }
            },
            handleError: function (data) {
                console.warn(data);
            }
        }

        return AjaxSearch;

}));